import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function AppShell({ children }) {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const location = useLocation();

    // Close the mobile drawer on every route change — belt-and-braces alongside
    // NavItem's own onClick close, in case navigation happens some other way.
    useEffect(() => { setMobileNavOpen(false); }, [location.pathname]);

    return (
        <div className="flex min-h-screen bg-background">
            <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
            <div className="flex-1 flex flex-col min-w-0">
                <Header onMenuClick={() => setMobileNavOpen(true)} />
                <main className="flex-1 px-4 sm:px-6 lg:px-10 py-6 lg:py-8 animate-fade-up">
                    {children}
                </main>
            </div>
        </div>
    );
}
